import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CourseExports } from '../../../../../../pages/project/settings/CourseExports';
import { Centered } from '../../../../../../components/atoms/layouts/Centered';
import { Loader } from '../../../../../../components/molecules/loader/Loader';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/course-exports')({
  component: CourseExportsRoute,
  pendingComponent: () => (
    <Centered>
      <Loader label="Loading exports..." />
    </Centered>
  ),
});

function CourseExportsRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <CourseExports projectId={project_id} portalApiClient={apiClient} />;
}
